export const qk = {
  ordersAll: ['orders'],
  ordersList: ['orders', 'list'],
  order: (id: number) => ['orders', id],
  orderEvents: (id: number) => ['orders', id, 'events'],
  orderFeedback: (id: number) => ['orders', id, 'feedback'],
  billing: ['billing'],
  billingPayments: ['billing', 'payments'],
  billingCreditHistory: ['billing', 'credits'],
  billingCreditHistoryInit: ['billing', 'credits', 'init'],
  billingCreditPackages: ['billing', 'credit-packages'],
  billingSubscriptionPlans: ['billing', 'subscription-plans'],
  sessions: ['sessions'],
  styleTemplates: ['styleTemplates'],
  customFields: ['custom-fields'],
  init: ['init'],
  login: ['login'],
  me: ['me'],
  oauthLogin: ['oauth'],
  signup: ['signup'],
  briefQuestions: ['orders', 'brief-questions'],
  orderBriefChoices: ['orders', 'brief-choices'],
  resetPasswordValidate: ['reset-password', 'validate'],
  createPasswordValidate: ['create-password', 'validate'],
  stripe: ['stripe'],
  countries: ['countries'],
  myTeam: ['profile', 'team'],
  dedicatedTeam: ['profile', 'team', 'dedicated-team'],
  joinTeam: ['join-team'],
  holidaysCalendar: ['holidays-calendar'],
  orderFormDetails: ['orders', 'forms', 'stepped-new', 'details'],
  orderFormCalculate: ['orders', 'forms', 'stepped-new', 'calculate'],
} as const;
